export enum RoutePath {
    stop, nonstop, transit
}